<style>
    div {
        background-color: transparent;
    }
</style>
<div stlye="background-color: transparent;" *ngIf="this.hasData == true">
    <pdfTemplate templateType="{{ templateType }}" [pdfModel]="pdfModel"></pdfTemplate>
</div>
